import ApiExtension from './api-extension'
import { toCamelCase, toSnakeCase } from '../object-utils'

export default class YieldEstimation extends ApiExtension {
  get(projectId) {
    return this.fetch('project_yield_estimations', {
      project_id: projectId,
    }).then(toCamelCase)
  }

  create(projectId, estimation) {
    return this.fetch(
      'project_yield_estimations',
      { project_id: projectId },
      {
        method: 'POST',
        body: JSON.stringify({
          yield_estimation: toSnakeCase(estimation),
        }),
      }
    )
  }

  update(yieldEstimationId, projectId, estimation) {
    return this.fetch(
      'project_yield_estimation',
      {
        id: yieldEstimationId,
        project_id: projectId,
      },
      {
        method: 'PUT',
        body: JSON.stringify({
          yield_estimation: toSnakeCase(estimation),
        }),
      }
    )
  }

  delete(yieldEstimationId, projectId) {
    return this.fetch(
      'project_yield_estimation',
      {
        id: yieldEstimationId,
        project_id: projectId,
      },
      {
        method: 'DELETE',
      }
    )
  }

  getMappings() {
    return this.fetch('yield_mappings')
  }

  createMapping(mapping) {
    return this.fetch(
      'yield_mappings',
      {},
      {
        method: 'POST',
        body: JSON.stringify({
          mapping,
        }),
      }
    )
  }

  updateMapping(id, mapping) {
    return this.fetch(
      'yield_mapping',
      { id },
      {
        method: 'PUT',
        body: JSON.stringify({
          mapping,
        }),
      }
    )
  }
}
